import { Component } from '@angular/core';

@Component({
  selector: 'app-privacyPolicy',
  templateUrl: './privacyPolicy.component.html',
  styleUrls: ['./privacyPolicy.component.css'],
  standalone: false
})
export class PrivacyPolicyComponent {
  
  constructor() {

  }


}
